import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react"
import {Link} from 'react-router-dom'

const REGISTRATION_URL = "/infor-cloud-suite-bootcamp";
const TICKER_ITEMS = ["Get Enrolled", "Get the Job"];

const CareerProgramTicker = () => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <div
      className="sticky top-16 z-40 overflow-hidden border-y border-[#0D5EF4] bg-[#0D5EF4] font-jost text-white xl:top-[76px]"
      role="region"
      aria-label="Infor career program highlights"
    >
      <motion.div
        className="flex w-max items-center"
        animate={shouldReduceMotion ? { x: 0 } : { x: ["0%", "-50%"] }}
        transition={
          shouldReduceMotion
            ? { duration: 0 }
            : { duration: 26, ease: "linear", repeat: Infinity }
        }
        style={{ willChange: "transform" }}
      >
        {[0, 1].map((copyIndex) => (
          <div
            key={copyIndex}
            className="flex shrink-0 items-center gap-5 whitespace-nowrap px-4 py-2.5 text-sm font-semibold uppercase tracking-[0.12em] sm:gap-8 sm:px-8 sm:py-3 sm:text-base"
            aria-hidden={copyIndex === 1}
          >
            {TICKER_ITEMS.map((item) => (
              <React.Fragment key={`${copyIndex}-${item}`}>
                <span className="inline-flex items-center gap-2">
                  <Sparkles className="h-4 w-4 text-white" aria-hidden="true" />
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-white" aria-hidden="true" />
              </React.Fragment>
            ))}
            <Link
              to='/career/infor-cloud-suite-bootcamp/apply'
              className="inline-flex items-center gap-1 rounded-full border border-white px-4 py-1.5 text-xs tracking-[0.08em] text-white transition-colors duration-200 hover:bg-white hover:text-[#0D5EF4] sm:text-sm"
              tabIndex={copyIndex === 1 ? -1 : undefined}
            >
              Apply Now <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default CareerProgramTicker;
